"use client";


import {Button} from "@/components/ui/button";
import AuthAction from "@/components/site/AuthAction";
import axios from "@/lib/axios";
import {getSession, useSession} from "next-auth/react";
import {authOptions} from "@/lib/authOptions";
import toast from "react-hot-toast";
import {useState} from "react";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {Form} from "@/components/ui/form";
import {useForm, useWatch} from "react-hook-form";
import Link from "next/link";
import CWFCheckbox from "@/components/ui/CWFCheckbox";
import CWFRadioGroup from "@/components/ui/CWFRadioGroup";
import {CWFInput} from "@/components/ui/CWFInput";
import BuyTicket from "@/app/(event)/events/[id]/BuyTicket";
import BuyTicketModal from "@/components/Payments/BuyTicketModal";
import ButtonPayment from "@/components/Payments/ButtonPayment";
const REQUIRED_ERROR = "Ce champ est requis.";


const formParticipateSchema = yup.object({

    acompagnate : yup.number().oneOf([1,2], "Veuillez fournir une valeur correcte.").required(REQUIRED_ERROR),
    email : yup.string().email("Veuillez fournir une adresse email valide").when("acompagnate",{
        is : 2,
        then : schema => schema.required(REQUIRED_ERROR),
    }),
    firstname : yup.string().when("acompagnate",{
        is: 2,
        then : schema => schema.required(REQUIRED_ERROR),
    }),
    lastname : yup.string().when("acompagnate",{is: 2,
    then : schema => schema.required(REQUIRED_ERROR)}),
    terms: yup.boolean()
        .oneOf([true], "Vous devez accepter nos conditions de participations pour continuer.")
        .required("Vous devez accepter nos conditions de participations pour continuer."),
    is_gift : yup.boolean(),
    cash : yup.boolean(),
})
export default function ApplyEvent({ eventId, onSuccess,nbTicket,price }) {

    const [participantOpen, setParticipantOpen] = useState(false);
    const [buyTicket, setBuyTicketOpen] = useState(false);
    const [ticket, setTicket] = useState(nbTicket);
    const formParticipate = useForm({
        resolver : yupResolver(formParticipateSchema),
        defaultValues : {
            acompagnate : 1
        }

    });

    const accompagnate = useWatch({control : formParticipate.control, name:"acompagnate"})
    const isCash = useWatch({control : formParticipate.control, name:"cash"})
    const isGift = useWatch({control : formParticipate.control, name:"is_gift"})
    const emailAccompagnate = useWatch({control : formParticipate.control, name:"email"})
    const firstnameAccompagnate = useWatch({control : formParticipate.control, name:"firstname"})
    const lastnameAccompagnate = useWatch({control : formParticipate.control, name:"lastname"})
    const acceptation = useWatch({control : formParticipate.control, name:"terms"})


    function preapply() {
        getSession(authOptions)
            .then(session => {
                    //console.log(nbTicket);
                    if(ticket === undefined){
                        setTicket(session.user.user.nb_ticket)
                    }
                    //setTicket(session.data.nb_ticket);
                    setParticipantOpen(true);
            });
            //setParticipantOpen(true);
    }


    function addParticipants(data){
        getSession(authOptions)
            .then(session => {

                if(data.acompagnate === 1){
                    axios.post(`/training/participant/${eventId}`, {cash : data.cash}, {
                        headers: {
                            Authorization: `Bearer ${session.user.token}`
                        }
                    })
                        .then(() => {
                            toast.success("Vous avez été préinscrit(e) avec succès.");
                            setParticipantOpen(false);
                            onSuccess?.();
                        })
                        .catch((err) => {
                            if(err.response.status === 422){
                                toast.success("Vous êtes déjà préinscrit(e).")
                            }else{
                                toast.error("Une erreur est survenue lors de votre préinscription.")
                            }
                        });
                }else{
                    axios.post(`/training/participant/${eventId}`, data, {
                        headers: {
                            Authorization: `Bearer ${session.user.token}`
                        }
                    })
                        .then(() => {
                            toast.success("Vous avez été préinscrit(e) avec succès.");
                            setParticipantOpen(false);
                            onSuccess?.();
                        })
                        .catch((err) => {
                            if(err.response.status === 422){
                                if(err.response.data.message === "Participant already exists"){
                                    toast.error("L'accompagnant est déjà inscrit a cette activité.")
                                }else{
                                    toast.success("Vous êtes déjà préinscrit(e).")
                                }
                            }else{
                                toast.error("Une erreur est survenue lors de votre préinscription.")
                            }
                        });
                }
            })

    }



    return (

        <>
            <AuthAction
                trigger={(
                    <Button>
                        Inscription
                    </Button>
                )}
                action={preapply}
            />
            <CWFResponsiveDialog
                open={participantOpen}
                onOpenChange={setParticipantOpen}
                title={<p>M&apos;inscrire à l&apos;événement</p>}
                trigger={null}
            >
               <Form {...formParticipate}>
                   <form onSubmit={formParticipate.handleSubmit(addParticipants)} className={"grid grid-cols-2 gap-2"}>

                       <CWFRadioGroup
                           control={formParticipate.control}
                           name="acompagnate"
                           label="Je serai"
                           className="col-span-2 gap-3"
                           orientation="horizontal"
                           options={[
                               {label: "Seul", value: 1},
                               {label: "Accompagné", value: 2},
                           ]}
                       />
                       {accompagnate === 2 && (
                           <>
                               <CWFInput control={formParticipate.control} name="firstname" label="Prénom" className={"input-ios"}/>
                               <CWFInput control={formParticipate.control} name="lastname" label="Nom" className={"input-ios"}/>
                               <CWFInput control={formParticipate.control} name="email" label="Email" className={"col-span-2 input-ios"}/>
                           </>
                       )}


                       <CWFCheckbox
                           control={formParticipate.control} className="col-span-2" name="terms"
                           label="Conditions de Participation"
                           description={(
                               <span className="text-xs">
                                    J&apos;accepte de participer à l&apos;événement en toute connaissance des risques associés à l&apos;exercice physique. Je m&apos;engage à respecter les consignes de sécurité et à ne pas tenir les organisateurs responsables des éventuels accidents.
                                </span>
                           )}
                       />
                       {accompagnate === 2 && (
                           <CWFCheckbox
                               control={formParticipate.control}
                               className="col-span-2"
                               name="is_gift"
                               label={"Ceci est un cadeau"}
                               description={(
                                   <span className="text-xs">
                                   En cliquant, les autres participants ne recevront pas de mails automatiques de notre part afin de préserver la surprise.
                               </span>
                               )}
                           />
                       )}
                       {(price && price > 0) &&(
                           <CWFCheckbox
                               control={formParticipate.control}
                               className="col-span-2"
                               name="cash"
                               label={"Je souhaite payer en espèces"}
                               description={(
                                   <span className="text-xs">
                                   En cliquant, vous serez pré-inscrit(e), il vous faudra payer à l&apos;accueil.
                               </span>
                               )}
                           />
                       )}

                       <div className={"col-span-2 flex justify-center"}>
                           {(price && price > 0)
                               ?
                               <>
                                   {isCash
                                       ?
                                       <div className={"flex justify-center items-center gap-x-4"}>
                                           <Button>Réserver</Button>
                                       </div>
                                       :
                                       <div className={"flex justify-center items-center gap-x-4"}>
                                           {ticket < accompagnate
                                               ?
                                               <ButtonPayment
                                                   type={"OPT"}
                                                   disabled={((accompagnate === 2 && (!acceptation || !firstnameAccompagnate || !emailAccompagnate || !lastnameAccompagnate)) || (accompagnate === 1 && !acceptation))}
                                                   name={"Réserver"}
                                                   product={process.env.NEXT_PUBLIC_PRODUCT_SINGLE}
                                                   redirect_id={eventId}
                                                   redirect_module={"opentraining"}
                                                   accompUserId={1}
                                                   accompEmail={emailAccompagnate}
                                                   accompFirstname={firstnameAccompagnate}
                                                   accompLastname={lastnameAccompagnate}
                                                   trainingId={eventId}
                                                   is_gift={isGift}
                                                   accompagnate={accompagnate}
                                               />
                                               :
                                               <Button>Réserver</Button>
                                           }

                                           <p
                                               className={"border-2 border-black rounded font-medium uppercase  px-4 py-1 cursor-pointer hover:bg-black hover:text-white"}
                                               onClick={() => {
                                                   setParticipantOpen(false);
                                                   setBuyTicketOpen(true)
                                               }}
                                           >
                                               Autre formule
                                           </p>
                                           {/*{ticket < accompagnate &&(
                                       <>
                                           <p className={"text-red-500 text-sm"}>Vous ne possédez pas suffisament de
                                               ticket pour la séance</p>
                                           <p className={"text-sm underline font-semibold text-center cursor-pointer"} onClick={() => {
                                               setParticipantOpen(false);
                                               setBuyTicketOpen(true)

                                           }}>Achetez en des maintenant</p>
                                       </>

                                   )}*/}
                                       </div>
                                   }

                               </>


                               :
                               <Button type={"submit"} className={``}>
                                   M&apos;inscrire
                               </Button>
                           }

                       </div>

                   </form>


               </Form>
            </CWFResponsiveDialog>
            <BuyTicketModal buyTicket={buyTicket} eventId={eventId} setBuyTicketOpen={setBuyTicketOpen}/>
            {/*<CWFResponsiveDialog open={buyTicket} onOpenChange={setBuyTicketOpen} trigger={null} title={"Choisissez la formule qui vous convient"}>
                <BuyTicket eventId={eventId}/>
            </CWFResponsiveDialog>*/}
        </>

    );
}